import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Button, Link, Typography } from '@mui/material';

import { useAuth } from 'contexts/AuthContext';
import { useToverHead } from 'hooks/useToverHead';
import { DefaultLayout } from 'components/page/layouts/DefaultLayout';
import PageHeaderSection from 'components/page/PageHeaderSection';
import PageSectionContainer from 'components/page/PageSectionContainer';
import { PageSectionDivider } from 'components/page/PageSectionDivider';
import ContactCard from 'components/service-center/ContactCard';

const Forbidden: FC = () => {
  const { t } = useTranslation();
  const {
    state: { account },
  } = useAuth();

  const description = t('lab.get-access.description');

  useToverHead({ title: 'lab.get-access.title', description });

  return (
    <DefaultLayout>
      <PageHeaderSection title={t('lab.get-access.title')} />

      <PageSectionContainer>
        <Typography gutterBottom>{description}</Typography>

        {!account && (
          <Box sx={{ mt: 2, mb: 4 }}>
            <Typography>{t('error.403.description')}</Typography>
            <Button sx={{ mt: 2 }} color="secondary" component={RouterLink} to="/request-invite">
              {t('opl.dialog.actions.request')}
            </Button>
          </Box>
        )}

        <Trans
          i18nKey="error.403.link.text"
          components={[<Link underline="always" href={t('error.403.link.href')} target="_blank" />]}
          parent="p"
        />
      </PageSectionContainer>

      <PageSectionDivider />

      <PageSectionContainer>
        <ContactCard />
      </PageSectionContainer>
    </DefaultLayout>
  );
};

export default Forbidden;
